"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuardTypeSerializer = exports.GuardType = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
/** Available guard types. */
var GuardType;
(function (GuardType) {
    GuardType[GuardType["BotTax"] = 0] = "BotTax";
    GuardType[GuardType["SolPayment"] = 1] = "SolPayment";
    GuardType[GuardType["TokenPayment"] = 2] = "TokenPayment";
    GuardType[GuardType["StartDate"] = 3] = "StartDate";
    GuardType[GuardType["ThirdPartySigner"] = 4] = "ThirdPartySigner";
    GuardType[GuardType["TokenGate"] = 5] = "TokenGate";
    GuardType[GuardType["Gatekeeper"] = 6] = "Gatekeeper";
    GuardType[GuardType["EndDate"] = 7] = "EndDate";
    GuardType[GuardType["AllowList"] = 8] = "AllowList";
    GuardType[GuardType["MintLimit"] = 9] = "MintLimit";
    GuardType[GuardType["NftPayment"] = 10] = "NftPayment";
    GuardType[GuardType["RedeemedAmount"] = 11] = "RedeemedAmount";
    GuardType[GuardType["AddressGate"] = 12] = "AddressGate";
    GuardType[GuardType["NftGate"] = 13] = "NftGate";
    GuardType[GuardType["NftBurn"] = 14] = "NftBurn";
    GuardType[GuardType["TokenBurn"] = 15] = "TokenBurn";
    GuardType[GuardType["FreezeSolPayment"] = 16] = "FreezeSolPayment";
    GuardType[GuardType["FreezeTokenPayment"] = 17] = "FreezeTokenPayment";
    GuardType[GuardType["ProgramGate"] = 18] = "ProgramGate";
    GuardType[GuardType["Allocation"] = 19] = "Allocation";
    GuardType[GuardType["Token2022Payment"] = 20] = "Token2022Payment";
})(GuardType = exports.GuardType || (exports.GuardType = {}));
function getGuardTypeSerializer() {
    return (0, serializers_1.scalarEnum)(GuardType, {
        description: 'GuardType',
    });
}
exports.getGuardTypeSerializer = getGuardTypeSerializer;
//# sourceMappingURL=guardType.js.map